import 'isomorphic-fetch';
import React from 'react'
import ReactDOM from 'react-dom';
import axios from 'axios';
import {flashMessage} from 'redux-flash';
import {Provider} from 'react-redux';
import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk'
import {Router, Route, Redirect, hashHistory} from 'react-router';
import {syncHistoryWithStore, routerMiddleware} from 'react-router-redux';
import {middleware as flashMiddleware} from 'redux-flash';
import {persistStore, persistReducer} from 'redux-persist';
import {createHashHistory, useBasename} from 'history';
import {loadTranslations, syncTranslationWithStore, setLocale} from 'react-redux-i18n';
import {isAdmin, isLogged} from './helpers/Helpers';
import {setLanguages} from './store/actions/language';
//import {pingMe} from '../../core/store/actions/user';
import {getGlobals} from './store/actions/global';
import {PersistGate} from 'redux-persist/es/integration/react';
import storage from 'redux-persist/lib/storage';
import reducers from './store/reducers';
import translations from './config/translations';
import Config from './config';
import asyncComponent from './AsyncComponent';

if (!global._babelPolyfill) {
    require('babel-polyfill');
}



/**
 * Async components: Backend Layout
 */
const MainLayout = asyncComponent(() => import('./components/Layouts/MainLayout'));
const LoginLayout = asyncComponent(() => import('./components/Layouts/LoginLayout'));
const FrontLayout = asyncComponent(() => import('../../frontend/components/Layouts/FrontLayout'));
const Preview = asyncComponent(() => import('../../frontend/pages/Preview'));

/**
 * Async components: Backend
 */
const HomeBackend = asyncComponent(() => import('./pages/Home'));
const WorkspaceBackend = asyncComponent(() => import('./pages/Workspace'));
const AddWorkspaceBackend = asyncComponent(() => import('./pages/AddWorkspace'));
const MediaBackend = asyncComponent(() => import('./pages/Media'));
const UsersBackend = asyncComponent(() => import('./pages/Users'));
const MenuBackend = asyncComponent(() => import('./pages/Menu'));
const PageBackend = asyncComponent(() => import('./pages/Page'));
const BlockBackend = asyncComponent(() => import('./pages/Block'));
const AddPageBackend = asyncComponent(() => import('./pages/AddPage'));
const AddBlockBackend = asyncComponent(() => import('./pages/AddBlock'));
const AddMenuBackend = asyncComponent(() => import('./pages/AddMenu'));
const AddGlobalFieldBackend = asyncComponent(() => import('./pages/AddGlobalField'));
const GlobalFieldBackend = asyncComponent(() => import('./pages/GlobalField'));

const authorizationIsOn = true;
var client = document.getElementById('application').getAttribute('data-client');
let initialLoad = true;
let renderer = "backend";
let initialRoute = document.getElementById('application').getAttribute('data-initial-route');


/**
 * Middleware
 */
const middleware = [
    thunkMiddleware,
    flashMiddleware(),
    routerMiddleware(hashHistory)
];

/**
 * Persist
 */
const persist = persistReducer({
    key: 'root',
    storage: storage,
    blacklist: [
        'flash',
        'routing',
        'media',
        'i18n'
    ]
}, reducers);

/**
 * Store configuration
 */
const store = createStore(persist, applyMiddleware(...middleware));

/**
 * Language syncsetLanguage
 */
syncTranslationWithStore(store);

if ((renderer !== "backend" && isLogged()) || !authorizationIsOn) {
    store.dispatch(loadTranslations(translations));
    store.dispatch(setLocale(Config.language));
    store.dispatch(setLanguages());
}

const gate = persistStore(store);
const basename = window.location.pathname + window.location.search;

const browserHistory = useBasename(createHashHistory)({
    basename: basename === '/' ? '' : ''
});

const history = syncHistoryWithStore(browserHistory, store);

/**
 * Configure axios
 */
axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    if (Config.getToken()){
        let message = 'Something went wrong. Please try again!';
        store.dispatch(
            flashMessage(message, {
                timeout: 0,
                props: {
                    type: 'error'
                }
            })
        );
    }


    return Promise.reject(error);
});

/**
 * Log out version
 */
console.log('version: 7.12');

/**
 * With backend layout
 */
const withBackendLayout = (WrappedComponent) => {
    return class WithAuthorization extends React.Component {

        componentDidMount() {
            document.body.classList.remove('front-page');
            document.body.classList.add('admin-page');
        }

        componentWillMount() {
            const {location: {pathname}} = this.props;
            if (initialLoad && initialRoute) {
                if (initialRoute !== pathname && pathname === '/') {
                    window.location.replace(window.location.href + initialRoute);
                    initialLoad = false;
                }
            }
        }

        render() {

            if (!isLogged() && authorizationIsOn) {
                return (
                    <LoginLayout {...this.props}>
                    </LoginLayout>
                );
            } else {
                return (
                    <MainLayout {...this.props}>
                        <WrappedComponent {...this.props} />
                    </MainLayout>
                );
            }
        }
    }
};

/**
 * With Frontend layout
 */
const withFrontendLayout = (WrappedComponent, frontendTheme, pageId) => {

    return class WithAuthorization extends React.Component {

        componentDidMount() {
            document.body.classList.remove('admin-page');
            document.body.classList.add('front-page');
            if (frontendTheme) {
                document.body.classList.add(frontendTheme);
            }
        }

        componentWillMount() {
            const {location: {pathname}} = this.props;

            if (initialLoad && initialRoute) {
                if (initialRoute !== pathname && pathname === '/') {
                    window.location.replace(window.location.href + initialRoute);
                    initialLoad = false;
                }
            }
        }

        render() {
            let props = this.props;
            if (pageId) {
                props.params.page = pageId;
            }

            if (!isLogged() && authorizationIsOn) {
                return (
                    <FrontLayout {...props} frontendTheme={frontendTheme}>
                        <LoginLayout {...this.props}>

                        </LoginLayout>
                    </FrontLayout>
                )
            } else {
                if (WrappedComponent){
                    <FrontLayout {...props} frontendTheme={frontendTheme}>
                        <WrappedComponent {...props} frontendTheme={frontendTheme}/>
                    </FrontLayout>
                } else {
                    return (
                        <FrontLayout {...props} frontendTheme={frontendTheme}>
                        </FrontLayout>
                    );
                }
            }
        }
    }
};


    ReactDOM.render(
        <Provider store={store}>
            <PersistGate persistor={gate}>
                <Router
                    history={history}
                    onUpdate={() => {
                        if (isAdmin()) {
                            store.dispatch(getGlobals());
                        }
                    }}
                >
                    <Route
                        path="/"
                        component={withBackendLayout(HomeBackend)}
                    />
                    <Route
	                    path='/preview'
	                    component={withFrontendLayout(Preview, client)}
                	/>
                    <Route
                        path="/workspace/:workspace"
                        component={withBackendLayout(WorkspaceBackend)}
                    />
                    <Route
                        path="/workspace/:workspace/page/:page/:language"
                        component={withBackendLayout(PageBackend)}
                    />
                    <Route
                        path="/workspace/:workspace/page/add"
                        component={withBackendLayout(AddPageBackend)}
                    />
                    <Route
                        path="/workspace/:workspace/block/:block/:language"
                        component={withBackendLayout(BlockBackend)}
                    />
                    <Route
                        path="/workspace/:workspace/block/add"
                        component={withBackendLayout(AddBlockBackend)}
                    />
                    <Route
                        path="/workspace/:workspace/menu/add"
                        component={withBackendLayout(AddMenuBackend)}
                    />
                    <Route
                        path="/workspace/:workspace/menu/:menu/:language"
                        component={withBackendLayout(MenuBackend)}
                    />
                    <Route
                        path="/add-global-field"
                        component={withBackendLayout(AddGlobalFieldBackend)}
                    />
                    <Route
                        path="/global-field/:key/:language"
                        component={withBackendLayout(GlobalFieldBackend)}
                    />
                    <Route
                        path="/add-workspace"
                        component={withBackendLayout(AddWorkspaceBackend)}
                    />
                    <Route
                        path="/media"
                        component={withBackendLayout(MediaBackend)}
                    />
                    <Route
                        path="/users"
                        component={withBackendLayout(UsersBackend)}
                    />
                    <Redirect from="*" to="/"/>
                </Router>
            </PersistGate>
        </Provider>,
        document.getElementById('application')
    );

export {
    basename,
    store
};


// WEBPACK FOOTER //
// ./src/core/admin/index.js